@if (!isDesktop()) {
  <app-header [transparent]="true"></app-header>
}
<div class="content" [class.desktop]="isDesktop()">
  @if (isDesktop()) {
    <div [class.desktop-sidebar]="isDesktop()">
      <app-sidebar
        (searchFilterChanged)="onSearchFilterChanged()"
        [showFilter]="true"
        [title]="
          i18n.langString('notifications') +
          ' [' +
          (NumEquipmentNotifications() + NumEdgeDeviceNotifications()) +
          ']'
        "
        [titleicon]="'bell'"
        [notificationsFilter]="true"
      >
        <app-tab-bar
          [fullWidth]="true"
          [opaque]="true"
          [icon]="true"
          (tabChanged)="onNotificationsTabBarChanged($event)"
          [disabled]="false"
        >
          <app-tab-bar-item
            class="one-of-two"
            [inactive]="false"
            svg_icon="assets/icons/repair_equipment.svg"
          >
            {{ i18n.langString("equipment_short") }} ({{
              NumEquipmentNotifications()
            }})
          </app-tab-bar-item>
          <app-tab-bar-item
            class="one-of-two"
            [inactive]="false"
            svg_icon="assets/icons/edge_device.svg"
          >
            {{ i18n.langString("edge_device_short") }} ({{
              NumEdgeDeviceNotifications()
            }})
          </app-tab-bar-item>
        </app-tab-bar>
      </app-sidebar>
    </div>
  }

  <div [class.desktop-main]="isDesktop()">
    @if (!isDesktop()) {
      <h2>
        {{ i18n.langString("notifications") }} [{{
          NumEquipmentNotifications() + NumEdgeDeviceNotifications()
        }}]
      </h2>
      <app-search-filter
        [filter]="filterSig()"
        [notificationsFilter]="true"
      ></app-search-filter>
    }

    @if (!showEdgeDeviceNotifications()) {
      <!-- Equipment notifications state -->
      @if (filtered() && NumEquipmentNotifications() > 1) {
        <div class="found-wrapper">
          <h3>
            {{ NumEquipmentNotifications() }}
            {{ i18n.langString("notifications_found") }}
          </h3>
        </div>
      } @else if (filtered() && NumEquipmentNotifications() === 1) {
        <div class="found-wrapper">
          <h3>1 {{ i18n.langString("notification_found") }}</h3>
        </div>
      } @else if (NumEquipmentNotifications() === 0 && !loading()) {
        <div class="found-wrapper">
          @if (filtered()) {
            <h3>{{ i18n.langString("no_notifications_found") }}</h3>
          }
          @if (filtered()) {
            <h5 class="marginTop24">
              {{ i18n.langString("no_equipments_found2") }}
            </h5>
          }
        </div>
      }
    }

    @if (showEdgeDeviceNotifications()) {
      <!-- Edge device notifications state -->
      @if (filtered() && NumEdgeDeviceNotifications() > 1) {
        <div class="found-wrapper">
          <h3>
            {{ NumEdgeDeviceNotifications() }}
            {{ i18n.langString("notifications_found") }}
          </h3>
        </div>
      } @else if (filtered() && NumEdgeDeviceNotifications() === 1) {
        <div class="found-wrapper">
          <h3>1 {{ i18n.langString("notification_found") }}</h3>
        </div>
      } @else if (NumEdgeDeviceNotifications() === 0 && !loading()) {
        <div class="found-wrapper">
          <h3>{{ i18n.langString("no_notifications_found") }}</h3>
          @if (filtered()) {
            <h5 class="marginTop24">
              {{ i18n.langString("no_equipments_found2") }}
            </h5>
          }
        </div>
      }
    }

    @if (loading()) {
      <app-spinner [black]="true"></app-spinner>
    }

    @if (!isDesktop()) {
      <app-tab-bar
        [fullWidth]="true"
        [opaque]="true"
        [icon]="true"
        (tabChanged)="onNotificationsTabBarChanged($event)"
        [disabled]="false"
      >
        <app-tab-bar-item
          class="one-of-two"
          [inactive]="false"
          svg_icon="assets/icons/repair_equipment.svg"
        >
          {{ i18n.langString("equipment_short") }} ({{
            NumEquipmentNotifications()
          }})
        </app-tab-bar-item>
        <app-tab-bar-item
          class="one-of-two"
          [inactive]="false"
          svg_icon="assets/icons/edge_device.svg"
        >
          {{ i18n.langString("edge_device_short") }} ({{
            NumEdgeDeviceNotifications()
          }})
        </app-tab-bar-item>
      </app-tab-bar>
    }

    @for (notification of Notifications(); track $index) {
      <app-notification
        [dateFormat]="dateFormat()"
        [notification]="notification"
        [filtered]="filtered()"
      ></app-notification>
    }
  </div>
</div>
